import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { firstValueFrom, Observable } from 'rxjs';

import { AppState } from './app.state';

@Injectable()
export class AppStoreDispatcher {
    constructor(
        private store: Store<AppState>
    ) { }

    public getState(): Observable<AppState> {
        return this.store.select((state: AppState) => state);
    }

    public getStateSnapshot(): Promise<AppState> {
        return firstValueFrom(this.store.select((state: AppState) => state));
    }
}
